import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";
import { formatMoneyByType } from "~utils/portfolio/formatNumber";

const ChartConfig = {
  default: {
    BALL_RADIUS: 5,
    LANE_X_START: 0,
    LANE_Y_POSITION: 19,
    BALL_Y_POSITION: 14,
    CHART_HEIGHT: 20,
  },
  stackedText: {
    BALL_RADIUS: 4,
    LANE_X_START: 0,
    LANE_Y_POSITION: 9,
    BALL_Y_POSITION: 5,
    CHART_HEIGHT: 10,
  },
};

type BowlingBallChartProps = {
  width: number;
  startValue: number;
  endValue: number;
  currentValue: number;
  tickerType: string;
  variation?: "default" | "stackedText";
};

function calculateBallPosition(
  startValue: number,
  endValue: number,
  currentValue: number,
  laneLength: number
) {
  if (endValue === startValue) {
    return laneLength / 2;
  }

  return ((currentValue - startValue) / (endValue - startValue)) * laneLength;
}

function formatValue(number: number, tickerType: string) {
  if (!number && number !== 0) {
    return "N/A";
  }

  return formatMoneyByType(number, tickerType);
}

export default function BowlingBallChart(props: BowlingBallChartProps) {
  const {
    width,
    startValue,
    endValue,
    currentValue,
    variation = "default",
    tickerType,
  } = props;
  const selectedChartConfig = ChartConfig[variation] || ChartConfig.default;
  const {
    BALL_RADIUS,
    LANE_X_START,
    LANE_Y_POSITION,
    BALL_Y_POSITION,
    CHART_HEIGHT,
  } = selectedChartConfig;
  const laneLength = width - 2 * BALL_RADIUS;
  const laneXEnd = LANE_X_START + width;

  const ballXPosition =
    BALL_RADIUS +
    calculateBallPosition(startValue, endValue, currentValue, laneLength);

  return (
    <div>
      <div className={createClasses(styles.text, styles[variation])}>
        <span className={createClasses(styles.textLeft, styles[variation])}>
          {formatValue(startValue, tickerType)}
        </span>
        <span className={createClasses(styles.textRight, styles[variation])}>
          {formatValue(endValue, tickerType)}
        </span>
      </div>
      <svg
        width={width}
        height={CHART_HEIGHT}
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1={LANE_X_START}
          y1={LANE_Y_POSITION}
          x2={laneXEnd}
          y2={LANE_Y_POSITION}
          className={styles.lane}
        />
        <circle cx={ballXPosition} cy={BALL_Y_POSITION} r={BALL_RADIUS} />
      </svg>
    </div>
  );
}
